package core.io.dto

import common.EEnvironmentVariables
import core.extensions.getValue
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 20.09.22
 * Author : mariorosshirt
 */

@Serializable
data class SceneDTOIn(

    @SerialName("sId")
    val mId: Int
) {
    val mImageUrl: String =
        "https://${EEnvironmentVariables.VEEUZE_HOST.getValue()}/api/getSceneImage/$mId?w=99999&h=278"
}